import styled from "styled-components";

export const PageContainer = styled.div`
  padding-top: 60px;
`;

export const FixedHeader = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
`;

export const Section = styled.section``;

export const ImagePlaceholder = styled.div`
  height: 300px;
  background-color: #e0e0e0;
`;

export const Form = styled.form``;

export const Carousel = styled.div``;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  column-gap: 4px;
  font-size: 15px;
  cursor: pointer;
  font-family: Mulish, sans-serif;
  border: none;
  border-radius: 4px;
  background: #0d51f1;
  color: #fff;
  margin-left: 10px;
  padding: 8px 15px;
  transition: background-color 300ms ease;
  &:first-child {
    margin-right: 12px;
  }
  &:hover {
    background-color: #fff;
    color: #0d51f1;
    border: 1px solid #0d51f1;
  }
`;

export const NavButton = styled.a`
  display: flex;
  justify-content: center;
  column-gap: 4px;
  font-size: 15px;
  cursor: pointer;
  font-family: Mulish, sans-serif;
  border: none;
  text-decoration: none;
  border-radius: 4px;
  background: #0d51f1;
  color: #fff;
  margin-left: 10px;
  padding: 8px 15px;
  transition: background-color 300ms ease;
  &:first-child {
    margin-right: 12px;
  }
  &:hover {
    background-color: #fff;
    color: #0d51f1;
    border: 1px solid #0d51f1;

    svg {
      fill: #0d51f1;
    }
  }
`;
